const React = require('react');


module.exports = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000 1000"
      {...props}
      className={'dB fillCT>g>path ' + (props.className || '')}
    >
      <g>
        <path d="M500,990C229.8,990,10,770.2,10,500C10,229.8,229.8,10,500,10c270.2,0,490,219.8,490,490C990,770.2,770.2,990,500,990z M500,55.6C254.9,55.6,55.6,255,55.6,500c0,245,199.4,444.4,444.4,444.4c245.1,0,444.4-199.4,444.4-444.4C944.4,255,745.1,55.6,500,55.6z M555.2,303.5c-33.4,0-60.5-27.1-60.5-60.5c0-33.4,27.1-60.5,60.5-60.5c33.4,0,60.5,27.1,60.5,60.5C615.7,276.4,588.6,303.5,555.2,303.5z M402.7,409.8c0-4.9,0-9.9,0-14.8c48-19.1,122-12.1,171.5-29.6c2,0,3.9,0,5.9,0c-23.9,121.1-74.3,231.2-85.8,354.9c2.7,2.1,2.4,1.6,5.9,2.9c37.2,12.5,58.6-74,82.8-68c24.3,6-15.2,49-20.7,56.2c-21.7,28.4-63.2,76.6-112.4,76.9c-34.7,0.2-70.7-21.7-65.1-79.8c5.7-58.2,38.3-139.2,56.2-204.1C455.5,452.1,474.1,408.4,402.7,409.8z"/>
      </g>
    </svg>
  );
};
